<template>
  <div class="create d-flex flex-column">

    <!-- Main Header -->
    <Header/>

    <!-- Email Input -->
    <form class="my-4" @submit.prevent="onSubmit">
      
      <!-- Alert -->
      <div v-if="alert" class="alert mb-4" :class="alertType == 'success' ? 'alert-primary' : 'alert-danger'" role="alert">

        <!-- Email Success -->
        <span v-if="alertType == 'success'"><b>Success!</b> An email has been sent to <b>{{sentTo}}</b> with the link to edit your Qintro.</span>

        <!-- Email doesn't Exist -->
        <span v-else-if="alertType == 'existing'"><b>Oops!</b> Email not found.</span>

        <!-- Error -->
        <span v-else><b>Oops!</b> An error has occured.</span>
      </div>
      <div v-if="alert && alertType == 'existing'" class="alert mb-4 p-0" role="alert">
        <span><b>Are you trying to create a new card?</b><br>Click <router-link to="/create" class="btn btn-link">here</router-link> to create a new Qintro QR card.</span>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <label>Enter your email address</label>
        </div>
        <div class="col">
          <input type="email" class="form-control" placeholder="Email Address" v-model="email" required>
        </div>
      </div>
      <button type="submit" class="btn btn-outline-success mt-4">
        <span v-if="!loading">Submit</span>
        <img v-else src="/assets/loader_white.gif" alt="loading">
      </button>
    </form>
    <Footer/>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'querystring';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default {
  data() {
    return {
      email: '',
      selectedEmail: '',
      alert: false,
      alertType: '',
      loading: false,
      sentTo: ''
    }
  },
  computed: {
    authToken: function() {
      return this.$store.state.authToken
    }
  },
  computed: {	
    authToken: function() {	
      return this.$store.state.authToken	
    }
  },
  components: {
    Header, Footer
  },
  methods: {
    maskEmail: function(str) {
      let split = str.split("@")
      let letter1 = split[0].substring(0, 1)
      let letter2 = split[0].substring(split[0].length - 1, split[0].length)
      let newFirst = letter1

      for(let i = 0; i < split[0].length - 2; i++) {
        newFirst += "*";
      }

      newFirst += letter2;
      
      let letter3 = split[1].substring(0, 1)
      let extension = letter3
      for(let i = 0; i < split[1].split(".")[0].length - 1; i++) {
        extension += "*"
      }

      extension += "." + split[1].split(".")[1]
      let result = newFirst + "@" + extension

      return result
    },
    updateAlert: function(type) {
      if(type == "success") {
        this.loading = false
        this.alert = true
        this.alertType = type;
      } else {
        this.loading = false
        this.alert = true
        this.alertType = type
      }
    },
    resetForm: function() {
      this.email = ''
    },
    sendEmailUpdateLink: function() {
      this.sentTo = this.maskEmail(this.selectedEmail)
      axios
      .get(process.env.VUE_APP_API+'/card/update-selected.php?email=' + this.email + '&email_selected=' + this.selectedEmail,
      {
        auth: { 	
          username: 'qintro-token',	
          password: this.authToken	
        } 	
      })
      .then((response) => {
        this.resetForm()
        this.updateAlert('success')
      })
      .catch(err => {
        if(err.response.status != 200) {
          this.$store.dispatch('expiredToken')
        } else {
          this.updateAlert('fail')
        }
      })
    },
    sendUpdateLink: function() {
      this.sentTo = this.maskEmail(this.email)
      axios
      .get(process.env.VUE_APP_API+'/card/update.php?email='+this.email, {
        headers: {
          'Content-Type': 'application/json'
        },
        auth: { 
          username: 'qintro-token',
          password: this.authToken
        } 
      })
      .then((response) => {
        this.resetForm()
        this.updateAlert('success')
        this.loading = false
      })
      .catch(err => {
        this.updateAlert('fail')
      })
    },
    getSecondaryEmail: function() {
      axios
      .get(process.env.VUE_APP_API+'/card/get-secondary-email.php?email='+this.email)
      .then((response) => {
        if(response.data != "" && response.data != this.email && response.data != null) { // if secondary email linked
          this.selectedEmail = response.data
          this.sendEmailUpdateLink()
        } else if(response.data == null) { // if no email exist
          this.updateAlert('existing')
          this.loading = false
        } else { // if no secondary email linked
          this.sendUpdateLink()
        }
      })
      .catch(err => {
        this.updateAlert('fail')
      });
    },
    onSubmit: function() {
      this.loading = true
      this.getSecondaryEmail()
    },
  },
  mounted() {
    this.$store.dispatch('checkSetAuthToken')
  }
}
</script>